import { Routes, Route, Navigate } from 'react-router-dom'
import { useIsAuthenticated, useMsal } from '@azure/msal-react'
import { InteractionStatus } from '@azure/msal-browser'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import Projects from './pages/Projects'
import ProjectDetail from './pages/ProjectDetail'
import Recordings from './pages/Recordings'
import GlobalRecordings from './pages/GlobalRecordings'
import SourceDocuments from './pages/SourceDocuments'
import WafCafAudit from './pages/WafCafAudit'
import AuditReports from './pages/AuditReports'
import Query from './pages/Query'
import Documents from './pages/Documents'
import GlobalDocuments from './pages/GlobalDocuments'
import Templates from './pages/Templates'
import OGTemplates from './pages/OGTemplates'
import Prompts from './pages/Prompts'
import PromptDetail from './pages/PromptDetail'
import Experiments from './pages/Experiments'
import BestPractices from './pages/BestPractices'
import Help from './pages/Help'
import Login from './pages/Login'
import SOWBuilder from './pages/SOWBuilder'
import EADashboard from './pages/EADashboard'
import EAProjects from './pages/EAProjects'
import EAProjectCreate from './pages/EAProjectCreate'
import EAProjectDetail from './pages/EAProjectDetail'
import EAVault from './pages/EAVault'
import EAVaultDocument from './pages/EAVaultDocument'
import EATaskSubmit from './pages/EATaskSubmit'
import EAPipelineView from './pages/EAPipelineView'
import EAArtifacts from './pages/EAArtifacts'
import EAArtifactPreview from './pages/EAArtifactPreview'
import EAQCReview from './pages/EAQCReview'
import EADeliverables from './pages/EADeliverables'
import EAHandoverLog from './pages/EAHandoverLog'
import EAGlobalLog from './pages/EAGlobalLog'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useIsAuthenticated()
  const { inProgress } = useMsal()

  if (inProgress !== InteractionStatus.None) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/projects/:projectId/audit-reports/present"
        element={
          <ProtectedRoute>
            <AuditReports presentationMode />
          </ProtectedRoute>
        }
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="projects" element={<Projects />} />
        <Route path="projects/:projectId" element={<ProjectDetail />} />
        <Route path="projects/:projectId/recordings" element={<Recordings />} />
        <Route path="projects/:projectId/source-documents" element={<SourceDocuments />} />
        <Route path="projects/:projectId/waf-caf-audit" element={<WafCafAudit />} />
        <Route path="projects/:projectId/audit-reports" element={<AuditReports />} />
        <Route path="projects/:projectId/query" element={<Query />} />
        <Route path="projects/:projectId/documents" element={<Documents />} />
        <Route path="recordings" element={<GlobalRecordings />} />
        <Route path="documents" element={<GlobalDocuments />} />
        <Route path="templates" element={<Templates />} />
        <Route path="og-templates" element={<OGTemplates />} />
        <Route path="prompts" element={<Prompts />} />
        <Route path="prompts/:promptId" element={<PromptDetail />} />
        <Route path="experiments" element={<Experiments />} />
        <Route path="best-practices" element={<BestPractices />} />
        <Route path="sow-builder" element={<SOWBuilder />} />
        <Route path="help" element={<Help />} />
        {/* EA-Orchestrator Routes */}
        <Route path="ea" element={<EADashboard />} />
        <Route path="ea/projects" element={<EAProjects />} />
        <Route path="ea/projects/new" element={<EAProjectCreate />} />
        <Route path="ea/projects/:projectId" element={<EAProjectDetail />} />
        <Route path="ea/projects/:projectId/task" element={<EATaskSubmit />} />
        <Route path="ea/projects/:projectId/pipeline" element={<EAPipelineView />} />
        <Route path="ea/projects/:projectId/artifacts" element={<EAArtifacts />} />
        <Route path="ea/projects/:projectId/artifacts/:artifactId" element={<EAArtifactPreview />} />
        <Route path="ea/projects/:projectId/qc" element={<EAQCReview />} />
        <Route path="ea/projects/:projectId/deliverables" element={<EADeliverables />} />
        <Route path="ea/log" element={<EAGlobalLog />} />
        <Route path="ea/projects/:projectId/log" element={<EAHandoverLog />} />
        <Route path="ea/vault" element={<EAVault />} />
        <Route path="ea/vault/:docId" element={<EAVaultDocument />} />
      </Route>
    </Routes>
  )
}

export default App
